var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * Map any object to another, using a map
 *
 * @param {Record<string, unknown>} input Data that is used as the input to each function in map
 * @param {ObjectMap} map Contains strings or functions that are called on each key/value pair of input
 * @returns {Record<string, unknown>} The mapped string
 */
export var mapper = function (input, map) { return input &&
    Object.entries(input).reduce(function (prevValue, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        var result = prevValue;
        var attributeMap = map[key];
        if (attributeMap !== undefined) {
            if (typeof attributeMap === 'function') {
                result = attributeMap(result, value);
            }
            else if (typeof attributeMap === 'string') {
                result[attributeMap] = value;
            }
            else {
                throw new TypeError("Invalid map type '" + typeof attributeMap + "' for '" + key + "'");
            }
        }
        else {
            result[key] = value;
        }
        return result;
    }, {}); };
//# sourceMappingURL=mapper.js.map